import React from "react";
import clsx from "clsx";

import Divider from "@material-ui/core/Divider";

import ScrollSyncPanel from "components/ScrollSync/ScrollSyncPanel/ScrollSyncPanel";
import HeaderCellContent from "./HeaderCellContent/HeaderCellContent";
import TableCellWrapper from "../TableCellWrapper/TableCellWrapper";
import { IHeaderCell, ITableHeaderColumnsContent } from "../types";

import useStyles from "./styles";

interface IProps {
  tabClassName: string;
  columns: string[];
  columnsContent: ITableHeaderColumnsContent;
}

const TableHeader = (props: IProps) => {
  const { tabClassName, columns, columnsContent } = props;

  const classes = useStyles();

  const renderHeaderCell = (cell: IHeaderCell) => {
    const { title, isDisplayed, sortableCell, highlighted } = cell;

    if (isDisplayed) {
      return (
        <HeaderCellContent
          title={title}
          sortableCell={sortableCell}
          highlighted={highlighted}
        />
      );
    }
  };

  const renderTableHeader = (
    columnData: IHeaderCell | IHeaderCell[],
    index?: number
  ) => {
    if (Array.isArray(columnData)) {
      return (
        <TableCellWrapper key={index} className={classes.headerCell}>
          {columnData.map((columnDataItem, index) => (
            <React.Fragment key={columnDataItem.title}>
              {Boolean(index) && (
                <Divider
                  className={classes.tableColumnDivider}
                  orientation="vertical"
                  flexItem
                />
              )}
              {renderHeaderCell(columnDataItem)}
            </React.Fragment>
          ))}
        </TableCellWrapper>
      );
    }

    return (
      <TableCellWrapper
        key={columnData.title}
        className={classes.headerCell}
        centered={columnData.centered}
        lastOneColumnCell={columnData.lastOneColumnCell}
        lastTwoColumnsCell={columnData.lastTwoColumnsCell}
        data-test-id={columnData.dataTestId}
      >
        {renderHeaderCell(columnData)}
      </TableCellWrapper>
    );
  };

  return (
    <>
      <div className={classes.tableHeader}>
        <ScrollSyncPanel className={classes.tableHeaderContainer}>
          <div className={clsx(classes.tableHeaderContent, tabClassName)}>
            {columns.map((column, index) =>
              renderTableHeader(columnsContent[column], index)
            )}
          </div>
        </ScrollSyncPanel>
      </div>

      <div className={classes.tableHeaderShadow} />
    </>
  );
};

export default TableHeader;
